import {client, database_id} from "../lib/appwrite";
import {Databases, Query} from "appwrite";
import {ExternalLinkItem} from "../types/links";
import {v4 as uuidv4} from "uuid";

const COLLECTION_ID = "685d84e5001f81dbe15f"
const databases = new Databases(client);

export const externalLinksService = {
  async list(queries: string[] = [], limit: number = 100): Promise<ExternalLinkItem[]> {
    try {
      const response = await databases.listDocuments(
        database_id,
        COLLECTION_ID,
        [
          Query.limit(limit),
          ...queries
        ]
      );
      const list = response.documents.map(doc => doc as unknown as ExternalLinkItem);
      return list;
    } catch (error) {
      throw error;
    }
  },
  async create(data: ExternalLinkItem): Promise<ExternalLinkItem> {
    try {
      const createdItem = await databases.createDocument(
        database_id,
        COLLECTION_ID,
        uuidv4(),
        data
      ) as unknown as ExternalLinkItem;

      return createdItem;
    } catch (error) {
      throw error;
    }
  },

  async update(data: ExternalLinkItem): Promise<ExternalLinkItem> {
    try {
      const id = data.$id as string
      const {$id, ...correctData} = data
      const updatedItem = await databases.updateDocument(
        database_id,
        COLLECTION_ID,
        id,
        correctData
      ) as unknown as ExternalLinkItem;
      return updatedItem;
    } catch (error) {
      throw error;
    }
  },
  async delete(id: string): Promise<void> {
    try {
      await databases.deleteDocument(
        database_id,
        COLLECTION_ID,
        id
      );
    } catch (error) {
      throw error;
    }
  },
}